import mantleLabsImg from "assets/images/projects/mantleLabs.jpeg";
import credilinqImg from "assets/images/projects/credilinq.jpeg";
import creditCardImg from "assets/images/projects/sbiCreditCard.jpeg";
import aksigenImg from "assets/images/projects/aksigen.jpeg";
import bharatMandiImg from "assets/images/projects/bharatMandi.jpeg";
import eleventhFloorImg from "assets/images/projects/eleventhFloor.jpeg";
import quickRecruitImg from "assets/images/projects/quickRecruit.jpeg";
import yugaPortImg from "assets/images/projects/yugaport.jpeg";
import magicOpsImg from "assets/images/projects/magicOps.ai.jpeg";
import tharraImg from "assets/images/projects/tharra.jpeg";
import pixFirstImg from "assets/images/projects/pixFirst.jpeg";

export const projectList = [
  {
    id: 1,
    image: mantleLabsImg,
    projectName: "Mantle Labs",
    projectLink: "https://mantle-labs.com/",
    projectDescription:
      "Maximize your nature-based project's potential with sustainable forestry and agriculture for impactful, scalable results."
  },
  {
    id: 2,
    image: credilinqImg,
    projectName: "Credilinq",
    projectLink: "https://credilinq.ai/",
    projectDescription:
      "A dynamic web app built with HTML, CSS, JavaScript, and ReactJS, featuring responsive design and interactive user interfaces."
  },
  {
    id: 3,
    image: creditCardImg,
    projectName: "SBI-Credit-Card Landing Page",
    projectLink:
      "https://www.titanencircle.com/titansbicard/?source=website&brand=titan&campaign=banner",
    projectDescription:
      "Create a responsive website using HTML, CSS, JavaScript, and ReactJS to showcase dynamic content and interactive features."
  },
  {
    id: 4,
    image: aksigenImg,
    projectName: "Aksigen",
    projectLink: "http://aksigen.s3-website-ap-southeast-1.amazonaws.com/",
    projectDescription:
      "Create a dynamic website using HTML, CSS, JavaScript, and ReactJS to showcase interactive portfolio content."
  },
  {
    id: 5,
    image: quickRecruitImg,
    projectName: "Quick Recruiter",
    projectLink: "https://quickrecruit.com/",
    projectDescription:
      "Developed a responsive web application using HTML, CSS, JavaScript, and React.js to enhance user experience and functionality."
  },
  {
    id: 6,
    image: bharatMandiImg,
    projectName: "Bharat Mandi",
    projectLink: "https://www.bharatmandi.com/",
    projectDescription:
      "Developed a responsive web application using HTML, CSS, JavaScript, and React.js for enhanced user interactivity and dynamic content presentation."
  },
  {
    id: 7,
    image: eleventhFloorImg,
    projectName: "EleventhFloor Company",
    projectLink: "https://eleventhfloorcompany.com/",
    projectDescription:
      "Create a responsive web application using HTML, CSS, JavaScript, and ReactJS to showcase interactive data visualizations."
  },
  {
    id: 8,
    image: yugaPortImg,
    projectName: "Yugaport",
    projectLink: "https://www.yugaport.com/",
    projectDescription:
      "Create a responsive web application using HTML, CSS, JavaScript, and ReactJS for dynamic user interactions and seamless interface updates."
  },
  {
    id: 9,
    image: tharraImg,
    projectName: "Tharra",
    projectLink: "https://tharra.s3-website-ap-southeast-1.amazonaws.com/",
    projectDescription:
      "Developed a dynamic e-commerce website using HTML, CSS, JavaScript, and ReactJS, enhancing user experience and functionality."
  },
  {
    id: 10,
    image: magicOpsImg,
    projectName: "Magicops.ai",
    projectLink: "https://magicops.ai/",
    projectDescription:
      "Developed a dynamic web application using HTML, CSS, JavaScript, and ReactJS to enhance user interaction and data management."
  },
  {
    id: 11,
    image: pixFirstImg,
    projectName: "Pix First",
    projectLink: "https://pix-first.s3-website-ap-southeast-1.amazonaws.com/",
    projectDescription:
      "Developed a dynamic e-commerce platform integrating HTML, CSS, JavaScript, and ReactJS for seamless user interaction and responsive design."
  }
];
